/**
 * Human-readable byte size. Raw bytes show no decimal (e.g. "512 B");
 * KB and up show one decimal (e.g. "1.5 KB", "5.0 GB"). Non-positive or
 * non-finite inputs render as "0 B".
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  const value = bytes / Math.pow(1024, i)
  return `${i === 0 ? value : value.toFixed(1)} ${units[i]}`
}
